// extracted by mini-css-extract-plugin
export var card = "cards-module--card--6e0b4";
export var cardGroup = "cards-module--cardGroup--3215c";
export var cards = "cards-module--cards--dfc90";
export var grid = "cards-module--grid--0481b";
export var headline = "cards-module--headline--4ef63";
export var headlineGroup = "cards-module--headlineGroup--6118e";